import { render, staticRenderFns } from "./help.vue?vue&type=template&id=5141e34a&scoped=true&"
import script from "./help.vue?vue&type=script&lang=js&"
export * from "./help.vue?vue&type=script&lang=js&"
import style0 from "./help.vue?vue&type=style&index=0&id=5141e34a&prod&lang=scss&scoped=true&"
import style1 from "./help.vue?vue&type=style&index=1&id=5141e34a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5141e34a",
  null
  
)

export default component.exports